import React, { useEffect, useState } from 'react';
// import { connect } from 'react-redux'

import MessageBoard from './MessageBoard';
import { allowed_types_component_menu } from './DropContext';

// Module actions
// import { addComponent, updateComponentIndexPos, updateDepthCompIndexPos, deleteMessage } from '../store/modules/MessageModule'
import { onDropComponent } from './DropComponentCommonFunctions';
import { DnD_element_type } from '../common/ConstantValues';
// import { setMsgChanges, setMsgUpdating } from '../store/modules/ResponseGenerationModule';

const MessageBoardContainer = (props) => {
  const { 
    // addComponent,
    messageActions,
    editing_message_index,
  } = props

  // Action for message data
  const {
    addComponent,
    updateDepthCompIndexPos,
    updateComponentIndexPos,
    setMsgChanges,
  } = messageActions

  // const { editingIndexes } = props
  // const { editing_message_index } = editingIndexes
  const { editCurrentMessage, currentEditSlidePage, isDragging, responseUpdateId } = props

  /**
   * props from parent component
   */
  const { currentEditMessage } = props

  /**
   * 메뉴 컴포넌트 onDrop
   * @param {Object} e 
   */
  const onDrop_menuComponent = (e) => {
    const { prefix_type, type, message_index, row_index } = e
    const prefix_type_keys = ["NORMAL", "SPECIAL"]
    
    // 유효성 검사
    if (prefix_type_keys.includes(prefix_type) && allowed_types_component_menu.includes(type)) {
      setMsgChanges(true) // Set message changes to true
      addComponent({
        message_index: message_index ? message_index : 0,
        ...e,
      })
      return
    }

    window.alert("컴포넌트의 Type이 올바르지 않아 컴포넌트를 추가할 수 없었습니다.")
  }

  /**
   * 컴포넌트 onDrop (row_index 0)
   */
  const onDrop_component = (e) => {
    const { message_index, type, prefix_type } = e
    setMsgChanges(true) // Set message changes to true 
    // Logic for depth components
    if (type === DnD_element_type.COMPONENT.NORMAL.GROUP && prefix_type === "NORMAL") {
      onDropComponent(updateDepthCompIndexPos, e, message_index, 0)
      return
    }
    onDropComponent(updateComponentIndexPos, e, message_index, 0)
  }

  return (
    <MessageBoard
      messages={currentEditMessage}
      onDropMenuComponent={onDrop_menuComponent}
      onDropComponent={onDrop_component}
      isDragging={isDragging}
      // editingIndexes={editingIndexes}
      editing={editing_message_index !== null}
      messageActions={messageActions}
      currentEditSlidePage={currentEditSlidePage}
      editing_message_index= {props.editing_message_index}
      editing_row_index= {props.editing_row_index}
      editing_slide_page_index= {props.editing_slide_page_index}
    />
  )
}

const mapStateToProps = (state) => ({
  // isDragging: state.DnD.isDragging,
  // editCurrentMessage: state.MessageModule.currentEditMessage,
  // editing_message_index: state.SlidePageState.message_index,
})

const mapDispatchToProps = (dispatch) => ({
  // addComponent : (arg) => {dispatch(addComponent(arg))},
  // deleteMessage_action : (message_index) => {dispatch(deleteMessage(message_index))},
  // updateComponentIndexPos : (arg) => {dispatch(updateComponentIndexPos(arg))},
  // updateDepthCompIndexPos : (arg) => {dispatch(updateDepthCompIndexPos(arg))},
  // setMsgChanges : (value) => {dispatch(setMsgChanges(value))},
  // setMsgUpdating : (value) => {dispatch(setMsgUpdating(value))},
})

export default MessageBoardContainer